<template>
  <div class="credit-module">
    <div class="credit-box">
      <div class="credit-label">
        <h3>{{ $t('DASHBOARD.CREDIT') }}</h3>
        <div class="hint text-grey text-sm">
          <span>{{ $t('DASHBOARD.NEXT_PAYOUT') }}:</span>
          <span v-if="!nextPayoutDate">{{
            $t('DASHBOARD.NEXT_PAYOUT_DATE', { month: nextPayoutMonth })
          }}</span>
          <span v-if="nextPayoutDate">{{ date(nextPayoutDate) }}</span>
        </div>
      </div>
      <WidgetError
        v-if="loadError"
        compact
        class="credit-error"
        @retry="fetchCredit"
      />
      <div v-else class="credit-amount">
        <h1>
          {{ creditBalance }}
        </h1>

        <SmartFaqLink :link="creditHelpLink.key" icon-only class="help-link" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { addMonths } from 'date-fns/addMonths';
import statisticsService from 'commons/api/statisticsService/statisticsService';
import date from 'commons/date/date';
import { parseISO } from 'date-fns/parseISO';
import SmartFaqLink from 'commons/helpLink/SmartFaqLink.vue';
import smartFaqLinks from 'commons/smartFaq/smartFaqLinks';
import WidgetError from 'src/app/components/error/WidgetError.vue';

export default {
  name: 'CreditModule',
  components: {
    SmartFaqLink,
    WidgetError,
  },
  data() {
    return {
      credit: null,
      iso: null,
      nextPayoutDate: null,
      nextPayoutMonth: null,
      loadError: false,
      creditHelpLink: smartFaqLinks.COMMISSION_INFO,
    };
  },
  computed: {
    ...mapState({
      user: (s) => s.user.data,
    }),
    ...mapGetters({
      shops: 'user/shops',
      currencyById: 'platform/currencyById',
    }),
    creditBalance() {
      if (this.credit && this.iso) {
        return this.sprdCurrency(this.credit.balance, this.iso);
      } else {
        return null;
      }
    },
  },
  created() {
    if (new Date().getDate() > 15) {
      this.nextPayoutMonth = date(addMonths(Date.now(), 1), 'MMMM');
    } else {
      this.nextPayoutMonth = date(new Date(), 'MMMM');
    }

    this.fetchCredit();
  },
  methods: {
    fetchCredit() {
      this.loadError = false;

      return statisticsService
        .getCreditOverview()
        .then((credit) => {
          this.credit = credit || {
            balance: 0,
            currencyId: this.user.currency.id,
            payoutLimitReached: false,
          };
          this.iso = this.currencyById(this.credit.currencyId).isoCode;
          if (this.credit.dateUpcomingPayout) {
            this.nextPayoutDate = parseISO(this.credit.dateUpcomingPayout);
          }
        })
        .catch((error) => {
          console.error('credit overview failed', error);
          this.loadError = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';
@import 'src/scss/styleguide/mixins';
@import 'src/scss/styleguide/type';

.credit-module {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  padding: 0 !important;
}

.credit-box {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 24px 24px 0 24px;
  background-color: $white;
  border-radius: $border-radius-medium;

  .credit-label {
    display: flex;
    flex-direction: column;
    margin: 0 24px 24px 0;
    position: relative;
    flex-grow: 1;

    & > h3 {
      margin: 0;
    }

    & > a {
      font-size: 12px;
      margin-top: 4px;
    }
  }

  .credit-amount {
    margin: 0 0 24px 0;
    display: flex;
    align-items: flex-end;

    & > h1 {
      margin: 0;
    }

    .help-link {
      margin-left: auto;
    }
  }

  .credit-error {
    margin: 0 0 24px 0;
  }

  .hint {
    margin-top: 8px;

    span {
      margin-right: 4px;
    }
  }
}
</style>
